// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2B2P0","footer":"ModalFilter_footer__lFALr"};